import { JsonObject, JsonProperty } from 'json2typescript';
import { Lawyer } from '../lawyers/lawyer';
import { CaseClientLite } from './caseClient';
import { CaseLawyer } from './caseLawyer';
import { CaseOpponentLite } from './caseOpponent';

export enum SequenceEnum {
    MARINE = 2,
    NON_MARINE = 4,
    PANDI = 5,
    SUDAN = 6
}

export enum StatusEnum {
    OPENED = 1,
    PENDING = 2,
    CLOSED = 3,
    PENDINGREOPEN = 4,
    PENDINGCLOSE = 5
}


@JsonObject('CaseLite')
export class CaseLite {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('sequence', Number, true)
    sequence: SequenceEnum = undefined;

    @JsonProperty('status', Number, true)
    status: StatusEnum = undefined;

    @JsonProperty('case_number', Number, true)
    caseNum = undefined;

    @JsonProperty('seq_number', String, true)
    seqNumber: string = null;

    @JsonProperty('open_date', String, true)
    openDate = null;

    @JsonProperty('closed_date', String, true)
    closedDate = null;

    @JsonProperty('case_type', String, true)
    caseType = '';

    @JsonProperty('subject', String, true)
    subject = '';

    @JsonProperty('city', String, true)
    city = '';

    @JsonProperty('lawyers', [CaseLawyer], true)
    lawyers: CaseLawyer[] = [];

    @JsonProperty('nm_lawyer', Lawyer, true)
    nmLawyer: Lawyer = null;

    @JsonProperty('court', String, true)
    court = '';

    @JsonProperty('opponents', [CaseOpponentLite], true)
    opponents = [];

    @JsonProperty('clients', [CaseClientLite], true)
    clients: CaseClientLite[] = [];

    @JsonProperty('created_by', String, true)
    createdBy: string = null;

    @JsonProperty('created_date', String, true)
    createdDate: string = null;

    @JsonProperty('reject_reason', String, true)
    rejectReason: string = null;

    get fileNum() {
        return this.seqNumber;
    }

    get isClosed() {
        return this.status === StatusEnum.CLOSED;
    }

    get isOpened() {
        return this.status === StatusEnum.OPENED;
    }

    get isNewCasePending() {
        return this.status === StatusEnum.PENDING;
    }

    get isClosedPending() {
        return this.status === StatusEnum.PENDINGCLOSE;
    }

    get isReopenPending() {
        return this.status === StatusEnum.PENDINGREOPEN;
    }

    get isPending() {
        return this.status === StatusEnum.PENDING || this.status === StatusEnum.PENDINGREOPEN || this.status === StatusEnum.PENDINGCLOSE;
    }

    get nmLawyerStr() {
        return this.nmLawyer?.getName;
    }

    get caseTypeStr() {
        return this.caseType;
    }

    // to match case with same properties(I used it in print files report from client files and lawyer files page)
    get clientsLite() {
        return this.clients;
    }

    get clientsLiteStr() {
        return this.clients.map(c => c.client).join(', ');
    }

    get opponentsLite() {
        return this.opponents;
    }
    // used in file filter form
    get caseSubjectStr() {
        return this.subject;
    }

}